import { XHRInstance } from "@sembark-travel/xhr"
import { THotelAddon } from "../HotelAddOns"

export function hotelAddOnsPricesXHR(xhr: XHRInstance) {
	return {
		async calculatePrices(
			hotelId: number,
			addon: THotelAddon,
			params: {
				quantity: number
				dates: Array<string>
			},
			options?: { signal?: AbortSignal }
		): Promise<{
			currency: string

			tax_percentage: string
			night_wise_rates: Array<{
				date: string
				is_available: boolean
				unavailable_reason: string | null

				rate_per_quantity_bt: string

				total_amount: string
			}>
		}> {
			const url = `/hotels/${hotelId}/ota-addons/${addon.id}/price-calculate`
			return xhr
				.get(url, { params, signal: options?.signal })
				.then((resp) => resp.data.data)
		},
	}
}
